import * as React from "react";
import Card from "react-bootstrap/Card";
import tileIcon from "../../svgs/tile-icon.svg";
import "../../css/homePageStyle.css";
import * as Icons from "../icons/NewIcons.tsx"
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import { ListGroup } from "react-bootstrap";

/* Interface for Tile Link details */
interface TileLinkProps {
  name: string;
  link: string;
  id: string;
}

/* Interface for Tile details */
interface TileProps {
  cardId: string;
  cardName: string;
  cardText: string | undefined;
  cardIcon: string | undefined;
  displayOnHover: boolean | undefined;
  cardLinks: TileLinkProps[];
  mouseEnter(): void | undefined;
  mouseLeave(): void | undefined;
}

// Tile Icons function
const tileIcons = (status) => {
  switch (status) {
    case "credit_card":
      return <Icons.LandingRebateWorkflowIcon style={{fontSize:"80px"}}/>;
    case "leaderboard":
      return <Icons.LandingPortfolioManagementIcon style={{fontSize:"80px"}}/>;
    case "meeting_room":
      return <Icons.LandingClientProfileSetupIcon style={{fontSize:"80px"}}/>;
    case "contact_page":
      return <Icons.LandingUserAdministrationIcon style={{fontSize:"80px"}}/>;
    case "home":
      return <Icons.LandingMyDashboardWhiteIcon style={{fontSize:"80px"}}/>;
    default:
      return <HomeOutlinedIcon style={{fontSize:"80px"}}/>;
  }
};

/* Individual Tile Component */
const Tile = ({
  cardId,
  cardName,
  cardText,
  displayOnHover,
  cardLinks,
  cardIcon,
  mouseEnter,
  mouseLeave,
}: TileProps) => {
  return (
    <>
      <Card
        className="mt-3 me-3"
        id={cardId}
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
      >
        <Card.Body>
          <Card.Title className="card-title">
            {cardName}
          </Card.Title>
          {cardId === "homePage" && displayOnHover && ( 
            <Card.Text className="card-text">{cardText}</Card.Text>
          )}
          <ListGroup variant="flush" className="list-group-item-value h-100">
            {displayOnHover ?
              cardLinks.map((item, index) => (
                <ListGroup.Item
                  className={`${
                    cardId === "homePage"
                      ? "mt-2 mb-2 home-card-list-group-item"
                      : "mt-2 card-list-group-item"
                  }`} key={index}
                >
                  <Card.Link key={index} className="card-link" href={item.link}>
                    {item.name}
                  </Card.Link>
                </ListGroup.Item>
              )):
                <div className="d-flex h-100 w-100 align-items-center justify-content-center">
                  {tileIcons(cardIcon)}
                </div>
              }
          </ListGroup>
        </Card.Body>
        {!displayOnHover && <img src={tileIcon} className="tile-icon" />}
      </Card>
    </>
  );
};

export default Tile;
